export default "__VITE_ASSET__BlYeVN$1__"